import React from "react";
import logger from "logger";
import Card from "@material-ui/core/Card";

export default function({ title, children }) {
  return (
    <Card
      style={{
        width: "auto",
        height: "auto",
        padding: "10px 16px 16px 16px",
        margin: "10px",
      }}
      className="enlargeonhover taskletcard"
    >
      {title && (
        <span className="headline" style={{ textAlign: "left" }}>
          {title}
        </span>
      )}
      {children}
    </Card>
  );
}
